'use client';

import { c as _c } from "react/compiler-runtime";
import { isApprovalOddsDisplayEligible, toEligibility } from '@repo/contracts/marketplace/offers/approvalOddsEligibility';
import type { RoundupDriverGroupEnum } from '@repo/contracts/marketplace/offers/enums';
import type { Offer } from '@repo/contracts/marketplace/offers/types';
import type { WithCss } from '@repo/pandacss/types';
import type { AnalyticsMarketplacePayload } from '@repo/platform-analytics/types';
import { useApprovalLikelihoodContext } from '@/features/approval-odds/context';
import { getCardsApprovalOddsDriver } from '@/features/approval-odds/getCardsApprovalOddsDriver';
import { useApprovalOddsLikelihood } from '@/features/approval-odds/useApprovalOddsLikelihood';
import type { ComponentDriver } from '../types';
import { Driver } from './Driver';
export function ApprovalOddsDriver(t0) {
  const $ = _c(17);
  const {
    approvalLikelihood,
    creditScore,
    productId,
    productName,
    isInstitutionAmex,
    marketplacePayload,
    driverGroup,
    css,
    segmentActionSection,
    isLtoHighlightingEnabled: t1
  } = t0;
  const isLtoHighlightingEnabled = t1 === undefined ? false : t1;
  const isEligible = isApprovalOddsDisplayEligible(toEligibility({
    product: {
      name: productName
    }
  }));
  let t2;
  if ($[0] !== marketplacePayload.section_name || $[1] !== marketplacePayload.section_position) {
    t2 = {
      sectionName: marketplacePayload.section_name,
      sectionPosition: marketplacePayload.section_position
    };
    $[0] = marketplacePayload.section_name;
    $[1] = marketplacePayload.section_position;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    label: approvalOddsLabel,
    value: approvalOddsValue
  } = useApprovalOddsLikelihood(t2, creditScore, isInstitutionAmex, isEligible ? approvalLikelihood : undefined);
  const {
    approvalLikelihoods,
    isLoading
  } = useApprovalLikelihoodContext();
  const approvalOdds = isEligible && approvalLikelihoods ? approvalLikelihoods[productId ?? ""] : undefined;
  let t3;
  if ($[3] !== approvalOddsLabel || $[4] !== approvalOddsValue) {
    t3 = {
      id: "recommendedCreditScore",
      label: approvalOddsLabel,
      value: approvalOddsValue
    };
    $[3] = approvalOddsLabel;
    $[4] = approvalOddsValue;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let driver = t3;
  if (approvalOdds) {
    let t4;
    if ($[6] !== approvalOdds.approvalLikelihood || $[7] !== isLoading) {
      t4 = getCardsApprovalOddsDriver(approvalOdds.approvalLikelihood, isLoading);
      $[6] = approvalOdds.approvalLikelihood;
      $[7] = isLoading;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    const approvalDriver = t4;
    let t5;
    if ($[9] !== approvalDriver) {
      t5 = {
        id: "recommendedCreditScore",
        ...approvalDriver
      };
      $[9] = approvalDriver;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    driver = t5;
  }
  let t4;
  if ($[11] !== css || $[12] !== driver || $[13] !== driverGroup || $[14] !== isLtoHighlightingEnabled || $[15] !== segmentActionSection) {
    t4 = <Driver driver={driver} driverGroup={driverGroup} css={css} segmentActionSection={segmentActionSection} isLtoHighlightingEnabled={isLtoHighlightingEnabled} />;
    $[11] = css;
    $[12] = driver;
    $[13] = driverGroup;
    $[14] = isLtoHighlightingEnabled;
    $[15] = segmentActionSection;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
}